
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.2 14.685h-2.4l-.3-5.686h3l-.3 5.686zM12 18.454a1.5 1.5 0 11.001-3.001 1.5 1.5 0 010 3zm9.734-.426L13.7 3.99a1.956 1.956 0 00-3.4 0L2.266 18.028a1.974 1.974 0 000 1.98c.345.614.996.994 1.7.99h16.067a1.94 1.94 0 001.7-.99 1.971 1.971 0 00.001-1.98z"}})])
          )
        }
      }
    